import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

const routeTitles: Record<string, string> = {
  '/home': 'Home',
  '/settings': 'Settings',
  '/login': 'Login',
};

export const TitleManager = () => {
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      const currentTitle = document.title;

      if (currentTitle === 'ChangeGPS') {
        let title = routeTitles[location.pathname];

        if (!title) {
          if (location.pathname.startsWith('/login')) {
            title = 'Login';
          } else if (location.pathname.startsWith('/settings')) {
            title = 'Settings';
          } else if (location.pathname.startsWith('/home')) {
            title = 'Home';
          } else {
            title = 'Page Not Found';
          }
        }

        const fullTitle = `ChangeGPS - ${title}`;

        document.title = fullTitle;
        if (window.top && window.top !== window) {
          window.top.document.title = fullTitle;
        }
      }
    }, 10);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
};
